/* eslint-disable global-require */
import React, {PureComponent} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {Menu} from 'antd';
import antdEx from 'icsoc-antd-ex';
import tCommonActions from 'Actions/common';

import {hasValueArray} from 'Utils';
import {findFstMenu, findSecMenu} from 'Utils/routeMenu';
import * as R from 'ramda';
import './index.less';

const {SubMenu} = Menu;
const {
  layout: {BaseContentSider},
} = antdEx;

const getRouteCodes = R.pipe(R.split('/'));
const getFstMenuCode = R.pipe(
  getRouteCodes,
  R.nth(1),
);
const getSecMenuCode = R.pipe(
  getRouteCodes,
  R.nth(2),
);
const getFirstMenu = (menuList, pathname) => {
  const fstMenuCode = getFstMenuCode(pathname);
  return findFstMenu(fstMenuCode, menuList);
};

class SubMenuContent extends PureComponent {
  state = {
    firstMenu: undefined,
  };

  static getDerivedStateFromProps(props, state) {
    const derivedState = {};
    // 路由或异步菜单发生变化时
    if (
      props.pathname !== state.prevPathname ||
      props.menuList !== state.prevMenuList
    ) {
      derivedState.firstMenu = getFirstMenu(props.menuList, props.pathname);
      derivedState.prevPathname = props.pathname;
      derivedState.prevMenuList = props.menuList;
    }
    return Object.keys(derivedState).length > 0 ? derivedState : null;
  }

  componentDidMount() {}

  //   componentDidUpdate(prevProps) {
  //     const {pathname, menuList} = this.props;
  //     const {pathname: prevname, menuList: prevMenu} = prevProps;
  //     if (pathname !== prevname || menuList !== prevMenu) {
  //       this.updateOperates();
  //     }
  //   }

  createMenu = (menu = {}, lastRoute) => {
    const {children} = menu;
    if (hasValueArray(children)) {
      return children.map(item => {
        const {children, to = '', name} = item;
        if (hasValueArray(children)) {
          return (
            <SubMenu key={to} title={name}>
              {this.createMenu(item, lastRoute)}
            </SubMenu>
          );
        }
        return (
          <Menu.Item key={to}>
            <Link to={`${to}`}>
              <span>{name}</span>
            </Link>
          </Menu.Item>
        );
      });
    }
    return [];
  };

  getDefaultKeys = (menuArr, pathname) => {
    const secMenuCode = getSecMenuCode(pathname);

    const {to} = findSecMenu(secMenuCode, menuArr);
    const selectedKeys = to ? [to] : [];
    // const defaultOpenKeys = parentIds.map(x => String(x));
    return {
      selectedKeys,
    };
  };

  //   updateOperates = () => {
  //     const {firstMenu} = this.state;
  //     const {pathname, commonActions} = this.props;
  //     if (!firstMenu) {
  //       return;
  //     }
  //     const secMenuCode = getSecMenuCode(pathname);
  //     const {operates} = findSecMenu(secMenuCode, firstMenu.children);
  //     commonActions.updateOperates(operates);
  //   };

  render() {
    const {pathname} = this.props;
    const {firstMenu} = this.state;
    if (!firstMenu) {
      return null;
    }
    const {name, children, redirect} = firstMenu;
    const {selectedKeys} = this.getDefaultKeys(children, pathname);
    const menus = this.createMenu(firstMenu, `${redirect}`);
    return (
      <BaseContentSider
        className="sub-menu-content"
        mode="inline"
        title={name}
        selectedKeys={[selectedKeys[0] || String(children[0].to)]}>
        {menus}
      </BaseContentSider>
    );
  }
}

const mapStateToProps = state => {
  return {
    menuList: state.common.menuList,
    pathname: state.routing.locationBeforeTransitions.pathname,
    login: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(tCommonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubMenuContent);
